import {Button, Modal, QRCode, Typography} from "antd";
import {useTranslation} from "react-i18next";
import TelegramIcon from "../assets/image/telegram.svg";

const {Text} = Typography;

// the qr is the same handoff either way, only the app named in the copy differs, so
// the provider is a prop and telegram stays the default for the callers that predate it
const COPY = {
    telegram: {
        titleKey: "linkedAccounts.telegramLinkTitle",
        titleDefault: "Link Telegram",
        scanKey: "linkedAccounts.telegramScanHint",
        scanDefault: "Scan with your phone camera, then tap Start in Telegram",
        hereKey: "linkedAccounts.telegramOnThisDevice",
        hereDefault: "Or, if Telegram is on this device",
        openKey: "linkedAccounts.telegramOpen",
        openDefault: "Open in Telegram",
        icon: TelegramIcon,
    },
    whatsapp: {
        titleKey: "linkedAccounts.whatsappLinkTitle",
        titleDefault: "Link WhatsApp",
        // they send us the message rather than receiving one, which is what proves the
        // number is theirs, so the instruction has to say send
        scanKey: "linkedAccounts.whatsappScanHint",
        scanDefault: "Scan with your phone camera, then send the message that opens",
        hereKey: "linkedAccounts.whatsappOnThisDevice",
        hereDefault: "Or, if WhatsApp is on this device",
        openKey: "linkedAccounts.whatsappOpen",
        openDefault: "Open in WhatsApp",
        icon: null,
    },
};

// desktop only: on a phone the link opens the app directly, so there is nothing to scan
const ProviderLinkModal = ({url, onClose, provider = "telegram"}) => {
    const {t} = useTranslation();

    const copy = COPY[provider] || COPY.telegram;

    return (
        <Modal
            open={!!url}
            title={t(copy.titleKey, {defaultValue: copy.titleDefault})}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            width={360}
        >
            <div style={{textAlign: "center"}}>
                <Text type={"secondary"} style={{fontSize: 12}}>
                    {t(copy.scanKey, {defaultValue: copy.scanDefault})}
                </Text>

                <div style={{margin: "16px 0", display: "flex", justifyContent: "center"}}>
                    {url ? (
                        <QRCode
                            value={url}
                            size={180}
                            icon={copy.icon || undefined}
                            iconSize={36}
                            errorLevel={"H"}
                        />
                    ) : null}
                </div>

                <Text type={"secondary"} style={{fontSize: 12}}>
                    {t(copy.hereKey, {defaultValue: copy.hereDefault})}
                </Text>

                <Button
                    type={"primary"}
                    block
                    style={{
                        marginTop: 8,
                        backgroundColor: "var(--primary-btn-bg-color)",
                        color: "var(--primary-btn-text-color)",
                        borderColor: "var(--primary-btn-border-color)",
                    }}
                    onClick={() => window.open(url, "_blank", "noopener")}
                >
                    {t(copy.openKey, {defaultValue: copy.openDefault})}
                </Button>
            </div>
        </Modal>
    );
};

export default ProviderLinkModal;
